module.exports = __webpack_public_path__ + "img/IMG_5885.6a9230f8.jpg";